export default __webpack_public_path__ + "static/timegrid-events-bad-7237283afebbd1afa136d144e86c7e3c.png";